import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const setAuthError = createAction('[Auth] Set Authentication Error', props<{ authError: HttpErrorResponse }>());
